module.exports = __webpack_public_path__ + "static/media/noDB.5c35f27d.jpg";